<template>
  <AppModal v-model="modalValue" @input="$emit('input', $event)" persistent max-width="750px">
    <template #app-modal-title>
      {{ title }}
    </template>
    <template v-slot:app-modal-alert>
      <ColumnNotImplementedMessage v-if="!implemented" :value="!implemented" />
      <MandatoryColumnMessage v-if="hasValidateAllValues && implemented" :value="hasValidateAllValues && implemented" />
    </template>
    <template #app-modal-text>
      <template v-if="configuration == null">
        Unknown column {{ columnId }}
      </template>
      <v-layout v-else row wrap>
        <v-flex xs12 v-if="hasDescription" pb-2 data-ui-component="column-description">
          <v-card-title class="title px-0 pb-2">Description</v-card-title>
          {{ configuration.Description }}
        </v-flex>
        <v-flex xs12>
          <slot name="edit-modal-additions" v-bind:configName="configName" v-bind:columnConfiguration="configuration" v-bind:editMode="editMode" v-bind:implemented="implemented">
          </slot>
        </v-flex>
        <v-flex v-if="!hasValidateAllValues && implemented" xs12 data-ui-component="skip-value-table">
          <v-card-title class="title px-0 pb-2">
            Skip Values
            <v-spacer />
            <v-btn color="success" @click="handleAddSkipValue" :disabled="!editMode || !implemented">Add Skip Value</v-btn>
          </v-card-title>
          <v-card-text class="pt-0">
            If a skip value is encountered in any cell within this column, the cell will be treated as an empty cell.
          </v-card-text>
          <SkipValueTable :columnConfiguration="configuration" :configName="configName" ref="skipValueTable" :editMode="editMode" :implemented="implemented" />
        </v-flex>

        <v-flex xs12 data-ui-component="alias-table">
          <v-card-title class="title px-0 pb-2">
            Column Name Aliases
            <v-spacer />
            <v-btn color="success" @click="handleAddAlias" :disabled="!editMode || !implemented">Add Alias</v-btn>
          </v-card-title>
          <v-card-text class="pt-0">
            Any alias in the table will be treated as match to the column.
          </v-card-text>
          <ColumnNameAliasTable :columnConfiguration="configuration" :configName="configName" ref="nameAliasTable" :editMode="editMode" :implemented="implemented" />
        </v-flex>
      </v-layout>
    </template>
    <template v-slot:app-modal-actions>
      <v-spacer />
      <v-btn color="primary" @click="close">Done</v-btn>
    </template>
  </AppModal>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'
  import genericMixin from '../../mixins/genericMixin'
  import AppModal from '../generic/AppModal'
  import MandatoryColumnMessage from './editModalComponents/MandatoryColumnMessage'
  import ColumnNotImplementedMessage from './editModalComponents/ColumnNotImplementedMessage'
  import ColumnNameAliasTable from './editModalComponents/ColumnNameAliasTable'
  import SkipValueTable from './editModalComponents/SkipValueTable.vue'

  import {
    VALIDATE_ALL_DATA,
  } from '../../store/columnDataValidationModes'
  const eddConfiguration = createNamespacedHelpers('plugin/eddConfiguration')

  export default {
    components: {
      AppModal,
      ColumnNotImplementedMessage,
      MandatoryColumnMessage,
      ColumnNameAliasTable,
      SkipValueTable,
    },
    mixins: [genericMixin],
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      configName: {
        type: String,
        required: true,
      },
      columnId: {
        type: String,
        required: true,
      },
      editMode: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        modalValue: false,
      }
    },
    computed: {
      ...eddConfiguration.mapGetters(['findColumnConfiguration']),
      configuration() {
        return this.findColumnConfiguration(this.configName, this.columnId)
      },
      columnDefaultName() {
        if (this.configuration == null || this.configuration.NameAliases == null) {
          return ''
        }
        let defaultName = this.configuration.NameAliases.find(x => x.IsDefault)
        return (defaultName && defaultName.Name) || this.configuration.Id
      },
      title() {
        return this.configuration ? `Edit ${this.columnDefaultName} Column Settings` : 'Unknown Column'
      },
      hasDescription() {
        return this.configuration && this.configuration.Description && this.configuration.Description != ''
      },
      hasValidateAllValues() {
        return this.configuration && this.configuration.DataValidationMode == VALIDATE_ALL_DATA
      },
      implemented() {
        return this.configuration && this.configuration.Implemented
      },
    },
    watch: {
      value() {
        this.modalValue = this.value
      },
    },
    methods: {
      close() {
        this.$emit('input', false)
      },
      handleAddAlias() {
        this.$refs.nameAliasTable.openAddAlias()
      },
      handleAddSkipValue() {
        this.$refs.skipValueTable.openAddSkipValue()
      },
    },
    mounted() {
      this.modalValue = this.value
    },
  }
</script>